module.exports = __webpack_public_path__ + "img/grondeigendom.e886d55d.png";